// extracted by mini-css-extract-plugin
export default {"main-content":"ErrorPage_main-content__P7vR-","status-code":"ErrorPage_status-code__InL8E"};